import React from 'react';
import { Row, Col } from 'antd';
import Button from 'components/Core/Button';
import { WorkshopRow, WorkshopContentCol, VideoCol } from './styles';
import { WebsiteImage } from 'components/TitleDescription';
import VideoButton from 'components/Core/Video/VideoButton';
import getBreakpointView from 'utils/getBreakpointView';

const Workshop = ({ title, featuredImage, excerpt, registrationLink, recordedVideo, gridMode }) => {
  const isMobile = getBreakpointView(['xs', 'sm']);

  return (
    <Col md={gridMode ? 8 : 24}>
      <WorkshopRow className={gridMode ? 'grid' : ''}>
        <Col className="image-row" md={24} xs={0}>
          {featuredImage && <WebsiteImage src={featuredImage.image} alt={featuredImage?.alt} />}
        </Col>
        <Row className="workshop-content">
          <WorkshopContentCol md={gridMode ? 24 : 20} xs={24}>
            <div className="content-container">
              <h5>{title}</h5>
              <p>{excerpt?.excerpt}</p>
            </div>
          </WorkshopContentCol>
          <Col md={gridMode ? 24 : 4} xs={24}>
            <Row>
              <Col
                md={gridMode ? 12 : 24}
                xs={12}
                style={{ textAlign: !isMobile && !gridMode ? 'right' : 'left', display: 'inline' }}
              >
                <Button type="secondary" size="small" to={registrationLink}>
                  Register Now
                </Button>
              </Col>
              <VideoCol md={gridMode ? 12 : 24} xs={12}>
                {recordedVideo && (
                  <VideoButton mainSrc={recordedVideo?.file?.url} title={'Watch Recording'} />
                )}
              </VideoCol>
            </Row>
          </Col>
        </Row>
      </WorkshopRow>
    </Col>
  );
};

export default Workshop;
